import handleRouterError from 'router/utils/handleRouterError';
import {getActualRouter} from 'router/utils/defineActualRouter';


function show404 () {
  const router = getActualRouter();
  router.replace({name: '404page', replace: true, params: {0: router.currentRoute.path}}).
    catch(handleRouterError);
}

function show403 () {
  const router = getActualRouter();
  router.replace({name: '403page', replace: true, params: {0: router.currentRoute.path}}).
    catch(handleRouterError);
}


export {show404, show403};
